module.exports = __webpack_public_path__ + "static/img/bonus_4.ad19530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/bonus_4.png
// module id = e0zG
// module chunks = 0